// let oldQty = 0;
// let hasGift = false;

// const handleGiftLogic = (Cart) => {
//   let giftQty = 0;
//   const items = Cart.getItems();
//   const itemsVariantTitle = items.filter((item) => item.variant_title.includes('/'));

//   const itemsFilteredByVendor = itemsVariantTitle.filter(
//     (item) => item.vendor == 'Sleepy' || item.vendor == 'Paradise' || item.vendor == 'Ted'
//   );

//   const itemsFilteredByType = itemsFilteredByVendor.filter((item) => item.product_type == 'Mattresses');

//   const singleSizeMattresses = itemsFilteredByType.filter((item) => +item.variant_title.split('/')[0] <= 120);
//   const doubleSizeMattresses = itemsFilteredByType.filter((item) => +item.variant_title.split('/')[0] > 120);

//   for (const item of singleSizeMattresses) {
//     giftQty += item.quantity;
//   }

//   for (const item of doubleSizeMattresses) {
//     giftQty += item.quantity * 2;
//   }

//   items.forEach((item) => {
//     if (item.variant_id == 46981803802967) {
//       hasGift = true;
//     }
//   });

//   if (giftQty != oldQty) {
//     Cart.changeItem({
//       id: 46981803802967,
//       quantity: giftQty,
//     });
//   }

//   oldQty = giftQty;

//   if (!hasGift) {
//     if (doubleSizeMattresses.length > 0 || singleSizeMattresses.length > 0) {
//       hasGift = true;

//       Cart.addItem({
//         id: 46981803802967,
//         quantity: giftQty,
//       });
//     }
//   }

//   if (giftQty == 0) {
//     hasGift = false;
//   }
// };

// document.addEventListener('rebuy:cart.ready', (event) => {
//   const Cart = window.Rebuy.Cart;

//   const giftItem = Cart.getItems().filter((item) => item.variant_id == 46981803802967);
//   const cartPageQuantity = giftItem.length
//     ? document.querySelector(`.cart__item[data-variant-id="${giftItem[0].variant_id}"] .quantity`)
//     : null;

//   if (cartPageQuantity) {
//     cartPageQuantity.value = giftItem[0].quantity;
//   }

//   handleGiftLogic(Cart);

//   document.addEventListener('rebuy:cart.change', (event) => {
//     handleGiftLogic(Cart);
//   });
// });

//NEW GIFT
// const GIFT_VARIANT_ID = 46981803802967;
const GIFT_VARIANT_ID = 50251071390039;
const SLEEPY_VENDOR_NAME = 'Sleepy';
const PRODUCT_TYPE = 'Mattresses';

const handleGiftLogic = (Cart, variantId, vendorName) => {
  // const items = Cart.getItems();
  // let giftQty = 0;

  // const sleepyItems = items.filter(
  //   (item) =>
  //     (item.product_id === 8137152528700 ||
  //       item.product_id === 8137152299324 ||
  //       item.product_id === 8647742030167 ||
  //       item.product_id === 8647779975511 ||
  //       item.product_id === 8647742030167 ||
  //       item.product_id === 8137171468604 ||
  //       item.product_id === 8137152332092) &&
  //     item.id !== GIFT_VARIANT_ID
  // );

  // const singleSizeMattresses = sleepyItems.filter((item) => +item.variant_title.split('/')[0] <= 120);
  // const doubleSizeMattresses = sleepyItems.filter((item) => +item.variant_title.split('/')[0] > 120);

  // const giftItem = items.find((item) => item.variant_id === GIFT_VARIANT_ID);
  // const hasGift = Boolean(giftItem);

  // for (const item of singleSizeMattresses) {
  //   giftQty += item.quantity;
  // }

  // for (const item of doubleSizeMattresses) {
  //   giftQty += item.quantity * 2;
  // }

  // if (giftQty !== (giftItem?.quantity || 0)) {
  //   Cart.changeItem({
  //     id: GIFT_VARIANT_ID,
  //     quantity: giftQty,
  //   });
  // }

  // if (!hasGift && giftQty > 0) {
  //   Cart.addItem({
  //     id: GIFT_VARIANT_ID,
  //     quantity: giftQty,
  //   });
  // }

  const items = Cart.getItems();
  let giftQty = 0;

  const sleepyItems = items.filter(
    (item) => item.vendor === vendorName && item.id !== variantId && item.product_type === PRODUCT_TYPE
  );

  const singleSizeMattresses = sleepyItems.filter((item) => +item.variant_title.split('/')[0] <= 120);
  const doubleSizeMattresses = sleepyItems.filter((item) => +item.variant_title.split('/')[0] > 120);

  const giftItem = items.find((item) => item.variant_id === variantId);
  const hasGift = Boolean(giftItem);

  for (const item of singleSizeMattresses) {
    giftQty += item.quantity;
  }

  for (const item of doubleSizeMattresses) {
    giftQty += item.quantity * 2;
  }

  if (giftQty !== (giftItem?.quantity || 0)) {
    Cart.changeItem({
      id: variantId,
      quantity: giftQty,
    });
  }

  if (!hasGift && giftQty > 0) {
    Cart.addItem({
      id: variantId,
      quantity: giftQty,
    });
  }
};

document.addEventListener('rebuy:cart.ready', (event) => {
  const Cart = window.Rebuy.Cart;

  const giftItem = Cart.getItems().find((item) => item.variant_id === GIFT_VARIANT_ID);
  const cartPageQuantity = giftItem
    ? document.querySelector(`.cart__item[data-variant-id="${giftItem.variant_id}"] .quantity`)
    : null;

  if (cartPageQuantity) {
    cartPageQuantity.value = giftItem.quantity;
  }
  handleGiftLogic(Cart, GIFT_VARIANT_ID, SLEEPY_VENDOR_NAME);
  document.addEventListener('rebuy:cart.change', (event) => {
    handleGiftLogic(Cart, GIFT_VARIANT_ID, SLEEPY_VENDOR_NAME);
  });
});
